import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import SectionRoadmap from './components/SectionRoadmap';
import { AdProvider } from './contexts/AdContext';

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <AdProvider>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/section/:sectionId" element={<SectionRoadmap />} />
        </Routes>
      </AdProvider>
    </BrowserRouter>
  );
};

export default AppRouter;